const HIGHLIGHT_SPLIT = /<em>(.*?)<\/em>/g;

/**
 * Render a `ts_headline` snippet with its matches emphasized. Split into elements
 * rather than set as HTML, since Postgres does not escape the user-authored text.
 */
export const SnippetText = ({ snippet }: { snippet: string }) => (
  <>
    {snippet.split(HIGHLIGHT_SPLIT).map((part, index) =>
      // With one capture group, the odd indexes are the `<em>` contents.
      index % 2 === 1 ? (
        <em key={index} className="rounded-sm bg-primary/10 px-0.5 not-italic text-foreground">
          {part}
        </em>
      ) : (
        part
      )
    )}
  </>
);
